const getLayout = (ratio) => {
  const [rWidth, rHeight] = ratio.split(':');
  const width = parseInt(rWidth);
  const height = parseInt(rHeight);
  if (width > height) return 'landscape';
  if (width < height) return 'portrait';
  if (width === height) return 'square';
};

export default getLayout;
